export default {
  meta: {
    title: '用户协议-邻汇',
    // url: '/user-agreement-linhui', // 埋点字段，上报归属的模块
    urlName: '用户协议-邻汇' // 埋点字段，上报归属的模块
  }
};
